__turbopack_context__.v({
  "btn": "registration-module-scss-module__ERRVAq__btn",
  "formGroup": "registration-module-scss-module__ERRVAq__formGroup",
  "registration": "registration-module-scss-module__ERRVAq__registration",
  "title": "registration-module-scss-module__ERRVAq__title",
});
